export default "__VITE_ASSET__CG3KWS11__"